function formatCurrency(amount: number | string, currency: string): string {
  if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return "Invalid amount";
  }

  const parsedAmount = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(parsedAmount)) {
    return "Invalid amount";
  }

  return (
    new Intl.NumberFormat("en-US", {
      style: "decimal",
    }).format(parsedAmount) + ` ${currency}`
  );
}

export default formatCurrency;
